export function firstnameFromDisplayName(displayName: string): string {
    return displayName.split(/\s+/).slice(0, -1).join(" ");
}

export function lastnameFromDisplayName(displayName: string): string {
    return displayName.split(/\s+/).slice(-1).join(" ");
}
